module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "IS-EB-5P-3.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('h1', {
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P1#Anchor"
    }
  }, [_vm._v("Copyright Information")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P4#Anchor-284"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P5#Anchor-125"
    }
  }, [_vm._v("Introduction: Steve Jobs and the “Vision Thing”")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-126"
    }
  }, [_vm._v("Quotations")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-131"
    }
  }, [_vm._v("Anxiety before iPad Debut")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-132"
    }
  }, [_vm._v("Apple’s Core: Employees")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-133"
    }
  }, [_vm._v("Apple’s DNA")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-134"
    }
  }, [_vm._v("Apple’s Existence")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-135"
    }
  }, [_vm._v("Attention Getting")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-136"
    }
  }, [_vm._v("Being the Best")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-137"
    }
  }, [_vm._v("Beyond Recruiting")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-138"
    }
  }, [_vm._v("Branding")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-139"
    }
  }, [_vm._v("Broad-Based Education")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-140"
    }
  }, [_vm._v("Broad Life Experiences, Importance of")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-141"
    }
  }, [_vm._v("Company Focus")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-142"
    }
  }, [_vm._v("Competition")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-143"
    }
  }, [_vm._v("Computers")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-144"
    }
  }, [_vm._v("Computers for Everyman")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-145"
    }
  }, [_vm._v("Computers as Tools")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-146"
    }
  }, [_vm._v("Confusing Product Lines")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-147"
    }
  }, [_vm._v("Consumerism")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-148"
    }
  }, [_vm._v("Consumer Product Design")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-149"
    }
  }, [_vm._v("Contribution")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-150"
    }
  }, [_vm._v("Convergence")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-151"
    }
  }, [_vm._v("Creating New Tools")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-152"
    }
  }, [_vm._v("Creativity and Technology")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-153"
    }
  }, [_vm._v("Credo")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-154"
    }
  }, [_vm._v("Customer Complaints")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-155"
    }
  }, [_vm._v("Customer Loyalty")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-156"
    }
  }, [_vm._v("David versus Goliath")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-157"
    }
  }, [_vm._v("Deadlines")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-158"
    }
  }, [_vm._v("Death")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-159"
    }
  }, [_vm._v("Decision Making")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-160"
    }
  }, [_vm._v("Demise")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-161"
    }
  }, [_vm._v("Dent in the Universe")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-162"
    }
  }, [_vm._v("Design")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-163"
    }
  }, [_vm._v("Difference, the Essential")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-164"
    }
  }, [_vm._v("Disney’s Animated Movie Sequels")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-165"
    }
  }, [_vm._v("E-Book Readers")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-166"
    }
  }, [_vm._v("Employee Motivation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-167"
    }
  }, [_vm._v("Employee Potential")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-168"
    }
  }, [_vm._v("Excellence")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-169"
    }
  }, [_vm._v("Excitement")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-170"
    }
  }, [_vm._v("Firing Employees")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-171"
    }
  }, [_vm._v("Flash Crash")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-172"
    }
  }, [_vm._v("Focus")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-173"
    }
  }, [_vm._v("Focusing on Product")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-174"
    }
  }, [_vm._v("Forcing the Issue")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-175"
    }
  }, [_vm._v("Forward Thinking")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-176"
    }
  }, [_vm._v("Getting It Right")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-177"
    }
  }, [_vm._v("Goals")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-178"
    }
  }, [_vm._v("Grace Under Pressure")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-179"
    }
  }, [_vm._v("Great Ideas")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-180"
    }
  }, [_vm._v("Great Product Design")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-181"
    }
  }, [_vm._v("Great Products")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-182"
    }
  }, [_vm._v("Hard Work")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-183"
    }
  }, [_vm._v("Health Speculation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-184"
    }
  }, [_vm._v("Health, Taking Time Off for")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-185"
    }
  }, [_vm._v("IBM")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-186"
    }
  }, [_vm._v("iCEO")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-187"
    }
  }, [_vm._v("Impact, in an Address to Apple Employees")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-188"
    }
  }, [_vm._v("Innovation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-189"
    }
  }, [_vm._v("Insight")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-190"
    }
  }, [_vm._v("Inspiration")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-191"
    }
  }, [_vm._v("Integration")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-192"
    }
  }, [_vm._v("Interdisciplinary Talents")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-193"
    }
  }, [_vm._v("Internet Theft and Motivation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-194"
    }
  }, [_vm._v("iPad and Inevitable Change")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-195"
    }
  }, [_vm._v("iPad Inspires iPhone")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-196"
    }
  }, [_vm._v("iPhone")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-197"
    }
  }, [_vm._v("iPod Nano")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-198"
    }
  }, [_vm._v("iPod Touch")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-199"
    }
  }, [_vm._v("iTunes")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-200"
    }
  }, [_vm._v("Jobs’s "), _c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("Curriculum Vitae")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Résumé)")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-201"
    }
  }, [_vm._v("Jobs’s Legacy at Apple")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-202"
    }
  }, [_vm._v("Jobs’s $1 Annual Salary")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-203"
    }
  }, [_vm._v("Letting Go of the Past")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-204"
    }
  }, [_vm._v("Life’s Complications")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-205"
    }
  }, [_vm._v("Losing Market Share")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-206"
    }
  }, [_vm._v("Losing Money")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-207"
    }
  }, [_vm._v("Lost Opportunities")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-208"
    }
  }, [_vm._v("Mac Cube")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-209"
    }
  }, [_vm._v("Mac’s Introduction")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-210"
    }
  }, [_vm._v("Mac Legacy")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-211"
    }
  }, [_vm._v("Making Bold Announcements")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-212"
    }
  }, [_vm._v("Marketing")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-213"
    }
  }, [_vm._v("Microsoft’s Lack of Innovation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-214"
    }
  }, [_vm._v("Microsoft’s Microview")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-215"
    }
  }, [_vm._v("Misplaced Values")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-216"
    }
  }, [_vm._v("Mistakes")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-217"
    }
  }, [_vm._v("Money")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-218"
    }
  }, [_vm._v("Motivating Employees")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-219"
    }
  }, [_vm._v("Motivation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-220"
    }
  }, [_vm._v("Need for Teamwork")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-221"
    }
  }, [_vm._v("Netbooks")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-222"
    }
  }, [_vm._v("New Products")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-223"
    }
  }, [_vm._v("No Resting on Laurels")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-224"
    }
  }, [_vm._v("Owning the User Experience")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-225"
    }
  }, [_vm._v("Packaging")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-226"
    }
  }, [_vm._v("PARC’s Graphical Interface")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-227"
    }
  }, [_vm._v("PARC’s Innovations")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-228"
    }
  }, [_vm._v("Parochial Thinking")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-229"
    }
  }, [_vm._v("Partnership")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-230"
    }
  }, [_vm._v("Passion")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-231"
    }
  }, [_vm._v("Passion versus Active Thinking")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-232"
    }
  }, [_vm._v("PC as the Digital Hub")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-233"
    }
  }, [_vm._v("Perception")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-234"
    }
  }, [_vm._v("Perseverance")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-235"
    }
  }, [_vm._v("Pixar")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-236"
    }
  }, [_vm._v("Pixar’s People")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-237"
    }
  }, [_vm._v("Porn Apps on Android")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-238"
    }
  }, [_vm._v("Pride in Product")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-239"
    }
  }, [_vm._v("Priorities Assessment")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-240"
    }
  }, [_vm._v("Process")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-241"
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-242"
    }
  }, [_vm._v("Product Creation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-243"
    }
  }, [_vm._v("Product Design")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-244"
    }
  }, [_vm._v("Product Imagination")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-245"
    }
  }, [_vm._v("Product Innovation")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-246"
    }
  }, [_vm._v("Product Integration")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-247"
    }
  }, [_vm._v("Product Secrecy")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-248"
    }
  }, [_vm._v("Products’ Appeal")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-249"
    }
  }, [_vm._v("Profit Sharing, Not Advances")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-250"
    }
  }, [_vm._v("Quality")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-251"
    }
  }, [_vm._v("Real Estate Location")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-252"
    }
  }, [_vm._v("Reliability")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-253"
    }
  }, [_vm._v("Repeating Success")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-254"
    }
  }, [_vm._v("Risking Failure")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-255"
    }
  }, [_vm._v("Shared Vision")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-256"
    }
  }, [_vm._v("Simplicity")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-257"
    }
  }, [_vm._v("Slogan: First Generation iPod")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-258"
    }
  }, [_vm._v("Software")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-259"
    }
  }, [_vm._v("Soul of the New Machine")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-260"
    }
  }, [_vm._v("Stagnation, the Danger of")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-261"
    }
  }, [_vm._v("Stickiness")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-262"
    }
  }, [_vm._v("Stock Options")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-263"
    }
  }, [_vm._v("Story, Importance of")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-264"
    }
  }, [_vm._v("Strategy")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-265"
    }
  }, [_vm._v("Success")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-266"
    }
  }, [_vm._v("Sucker-Punched, Being")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-267"
    }
  }, [_vm._v("Survival")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-268"
    }
  }, [_vm._v("Takeovers, Hostile")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-269"
    }
  }, [_vm._v("Taking Stock of Apple")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-270"
    }
  }, [_vm._v("Teamwork")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-271"
    }
  }, [_vm._v("Technology in Perspective")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-272"
    }
  }, [_vm._v("“Think Different” Ad Campaign")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-273"
    }
  }, [_vm._v("Thinking Through the Problem")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-274"
    }
  }, [_vm._v("To Be or Not to Be")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-275"
    }
  }, [_c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("Toy Story 2")])])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-276"
    }
  }, [_vm._v("Trash Talking")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-277"
    }
  }, [_vm._v("Ubiquity of Mac")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-278"
    }
  }, [_vm._v("User Experience")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-279"
    }
  }, [_vm._v("Values")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-280"
    }
  }, [_vm._v("Vision")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-281"
    }
  }, [_vm._v("Wisdom")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-282"
    }
  }, [_vm._v("Working Hard and Growing Older")])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "#/ISEB5P6#Anchor-283"
    }
  }, [_vm._v("Zen")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P7#Anchor-127"
    }
  }, [_vm._v("Milestones")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P8#Anchor-128"
    }
  }, [_vm._v("End of an Era: Steve Jobs’s Resignation Letter as Apple CEO")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P9#Anchor-129"
    }
  }, [_vm._v("Citations")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "#/ISEB5P10#Anchor-130"
    }
  }, [_vm._v("About the Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c094bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IS-EB5P-3.vue
// module id = 66
// module chunks = 0